import {Button, styled} from "@mui/material";
import React, {ComponentProps, PropsWithChildren} from "react";

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const UploadButton = ({
                          startIcon,
                          disabled,
                          children,
                          accept,
                          onFileSelected,
                      }: PropsWithChildren<{ accept?: string, onFileSelected: (files: FileList | null) => void }>
    & Pick<ComponentProps<typeof Button>, 'startIcon' | 'disabled'>) => {
    return (
        <Button
            component="label"
            role={undefined}
            tabIndex={-1}
            disabled={disabled}
            startIcon={startIcon}
        >
            {children}
            <VisuallyHiddenInput
                type="file"
                accept={accept}
                onChange={(event) => onFileSelected(event.target.files)}/>
        </Button>
    );
};
